<template>
  <div>
    <div class="page-header">
      <div class="add-item d-flex">
        <div class="page-title">
          <h4>{{ $t("item") }}</h4>
        </div>
      </div>

<!--      <ul class="table-top-head">-->
<!--        <li>-->
<!--          <a data-bs-toggle="tooltip" data-bs-placement="top" title="Pdf"><img src="/assets/img/icons/pdf.svg" alt="img"></a>-->
<!--        </li>-->
<!--        <li>-->
<!--          <a data-bs-toggle="tooltip" data-bs-placement="top" title="Excel"><img src="/assets/img/icons/excel.svg" alt="img"></a>-->
<!--        </li>-->
<!--        <li>-->
<!--          <a data-bs-toggle="tooltip" data-bs-placement="top" title="Print"><i class="ti ti-printer"></i></a>-->
<!--        </li>-->
<!--        <li>-->
<!--          <a data-bs-toggle="tooltip" data-bs-placement="top" title="Refresh"><i class="ti ti-refresh"></i></a>-->
<!--        </li>-->
<!--        <li>-->
<!--          <a data-bs-toggle="tooltip" data-bs-placement="top" title="Collapse" id="collapse-header"><i class="ti ti-chevron-up"></i></a>-->
<!--        </li>-->
<!--      </ul>-->

      <div class="page-btn">
        <router-link v-if="can('inventory.item', 'W')" to="/item/create" class="btn btn-added">
          <i class="ti ti-circle-plus me-2 text-white"></i>{{ $t("add_new_item") }}
        </router-link>
      </div>
    </div>

    <!-- /item list -->
    <div class="card table-list-card">
      <div class="card-body">

        <div class="table-responsive">
          <DataTable v-if="items.length" ref="dtRef" :tableId="'ItemTable'">
            <thead>
              <tr>
                <th>{{ $t("item_code") }}</th>
                <th>{{ $t("item_name") }}</th>
                <th>{{ $t("image") }}</th>
                <th>{{ $t("sku") }}</th>
                <th>{{ $t("category") }}</th>
                <th>{{ $t("sub_category") }}</th>
                <th>{{ $t("warehouse") }}</th>
                <th>{{ $t("size") }}</th>
                <th>{{ $t("color") }}</th>
                <th>{{ $t("model_number") }}</th>
                <th>{{ $t("unit") }}</th>
                <th>{{ $t("reorder_level") }}</th>
                <th>{{ $t("barcode_qr_code") }}</th>
                <th>{{ $t("selling_price") }}</th>
                <th>{{ $t("discount") }}</th>
                <th>{{ $t("vat_group") }}</th>
                <th>{{ $t("stock_quantity") }}</th>
                <th class="no-sort">{{ $t("action") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in items" :key="item.id">
                <td>{{ item.item_code }}</td>
                <td>{{ item.item_name }}</td>
                <td>
                  <div v-if="item.images && item.images.length" >
                    <img :src="item.images[0].small_thumb" alt="Item Image" />
                  </div>
                  <div v-else >
                    {{ $t("no_image") }}
                  </div>
                </td>
                <td>{{ item.sku }}</td>
                <td>{{ item.category_name }}</td>
                <td>{{ item.sub_category_name }}</td>
                <td>{{ item.warehouse_name }}</td>
                <td>{{ item.size_name }}</td>
                <td>{{ item.color_name }}</td>
                <td>{{ item.model_number }}</td>
                <td>{{ item.unit_name }}</td>
                <td>{{ item.reorder_level }}</td>
                <td>{{ item.barcode_qr_code }}</td>
                <td>{{ item.selling_price }}</td>
                <td>{{ item.discount }}</td>
                <td>{{ item.vat_group_name }}</td>
                <td>{{ item.stock_quantity }}</td>

                <td class="action-table-data">
                  <div v-if="can('inventory.item', 'E')" class="edit-delete-action">
                    <router-link :to= "{name:'EditItem',params:{id:item.id}}"
                     class="btn btn-added" @create_success="fetchItem">
                      <i class="ti ti-edit me-2"></i>{{ $t("edit_item") }}
                    </router-link>
                  </div>
                </td>
              </tr>
            </tbody>
          </DataTable>
          <div v-else class="d-flex flex-column align-items-center justify-content-center p-5 bg-light rounded shadow-sm">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="#6c757d" class="mb-3" viewBox="0 0 16 16">
              <path d="M8 0a8 8 0 1 0 8 8A8.009 8.009 0 0 0 8 0zm0 15A7 7 0 1 1 15 8a7.008 7.008 0 0 1-7 7z"/>
              <path d="M5.354 4.646a.5.5 0 0 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z"/>
            </svg>
            <h5 class="text-muted">No Data Found</h5>
            <p class="text-secondary small">Try adjusting filters or add new data.</p>
          </div>
        </div>

  <!--      <div class="d-flex justify-content-between align-items-center mt-3">-->
  <!--        <div>-->
  <!--          {{ $t("showing") }}-->
  <!--          <strong>{{ (currentPage - 1) * pageSize + 1 }}</strong>-->
  <!--          - -->
  <!--          <strong>{{ Math.min(currentPage * pageSize, totalItems) }}</strong>-->
  <!--          {{ $t("of") }}-->
  <!--          <strong>{{ totalItems }}</strong>-->
  <!--        </div>-->

  <!--        <div>-->
  <!--          <button @click="goToPreviousPage" :disabled="!previousPage" class="btn btn-outline-primary me-2">-->
  <!--            {{ $t("previous") }}-->
  <!--          </button>-->
  <!--          <button @click="goToNextPage" :disabled="!nextPage" class="btn btn-outline-primary">-->
  <!--            {{ $t("next") }}-->
  <!--          </button>-->
  <!--        </div>-->
  <!--      </div>-->

      </div>
    </div>
    <!-- /item list -->

  </div>
</template>

<script>
import apiUrls from '@/urls';
import DataTable from '@/components/common/DataTable.vue';
import CreateItem from '@/views/admin_dashboard/item/CreateItem.vue';
import EditItem from '@/views/admin_dashboard/item/EditItem.vue';

export default {
  inject: ['globalLoading'],
  components: {
    DataTable,
    CreateItem,
    EditItem,
  },
  data() {
    return {
      items: [], // Store fetched items
	    selectedItem: {},
      // currentPage: 1,
      // nextPage: null,
      // previousPage: null,
      // totalItems: 0,
      // pageSize: 50,
    };
  },

  methods: {
    async fetchItem(page=1) {
      this.globalLoading(true)
      try {
        const response = await this.$axios.get(apiUrls.item.get);
        // const response = await this.$axios.get(`${apiUrls.item.get}?page=${page}`);
        this.items = response.data;
        // this.totalItems = response.data.count;
        // this.nextPage = response.data.next;
        // this.previousPage = response.data.previous;
        // this.currentPage = page;

        // Automatically assign the first item if available
        if (this.items.length > 0) {
          this.selectedItem = this.items[0];
        }

        // this.$refs.dtRef.mountDtable()
      } catch (error) {
        console.error("Error fetching item:", error);
      } finally {
        this.globalLoading(false)
      }
    },

    // goToNextPage() {
    //   if (this.nextPage) this.fetchItem(this.currentPage + 1);
    // },
    //
    // goToPreviousPage() {
    //   if (this.previousPage && this.currentPage > 1) this.fetchItem(this.currentPage - 1);
    // },

    // Method to select an item based on user interaction
    selectItem(item) {
      this.selectedItem = item;
    },

    can(code, requiredLevel) {
      const perms = JSON.parse(localStorage.getItem("permissions")) || {};
      const userLevel = perms[code] || 'N';

      for (const char of requiredLevel) {
        if (!userLevel.includes(char)) {
          return false;
        }
      }
      return true;
    },
  },

  created() {
    this.fetchItem();
  },
};
</script>
